import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { GroupsService } from './groups.service';

@Injectable({
  providedIn: 'root'
})
export class GroupsResolve implements Resolve<any> {

  constructor(private gs: GroupsService) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.gs.updateGroups()
  }
}
